export default {
  header: {
    hideMenuBar: 'Skrýt panel nabídek',
    showMenuBar: 'Zobrazit panel nabídek'
  }
}
